import { useEffect, useState } from "react";

// Stato di pagina (filtri, tab, periodo, ordinamento) conservato nella sessione del browser
export function usePageState(key, initial) {
  const storageKey = `ps:${key}`;
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      return raw != null ? JSON.parse(raw) : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* quota */ }
  }, [storageKey, value]);
  return [value, setValue];
}
